/*eslint-disable */
import React, { useRef } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";

const SYNC_FILES = [
  "AUTH_Account.json",
  "AUTH_Auth.json",
  "COMPANY_Company.json",
  "CRM_Contacts.json",
  "CRM_Contacts_Issues.json",
  "CRM_Conversation.json",
  "CRM_Ecoleads.json",
  "CRM_Label.json",
  "CRM_Leads.json",
  "CRM_List.json",
  "CRM_MailTemplate.json",
  "CRM_Notes.json",
  "CRM_Opportunity.json",
  "EVENT_Events.json",
  "EVENT_Groups.json",
  "PROJECT_Projects.json",
  "SURVEY_Survey.json",
  "UPLOAD_Upload.json",
];

const getFileLabel = (filename) => {
  const parts = filename.replace(".json", "").split("_");
  return parts[0] + " - " + parts.slice(1).join(" ");
};

const ApiDocsHeader = ({
  breadCrumbText,
  reloadList = () => {},
  downloadAsExcel = () => {},
  jsonFilterQuery = [],
  syncFromJson = () => {},
  isSyncing = false,
}) => {
  const { t } = useTranslation(); //for translation
  const syncBtnRef = useRef(null);

  const handleSyncClick = (file) => {
    // Close Bootstrap dropdown before React re-render from isSyncing state change
    const btn = syncBtnRef.current;
    if (btn) {
      if (window.bootstrap?.Dropdown) {
        const instance =
          window.bootstrap.Dropdown.getInstance(btn) ||
          new window.bootstrap.Dropdown(btn);
        instance.hide();
      } else {
        // Fallback: manually strip Bootstrap show classes
        btn.setAttribute("aria-expanded", "false");
        const menu = btn.nextElementSibling;
        if (menu) menu.classList.remove("show");
        btn.closest(".dropdown")?.classList.remove("show");
      }
    }
    syncFromJson(file);
  };

  return (
    <div className="bg-white pt-3 mb-3">
      <div className="d-flex justify-content-between align-items-center flex-column flex-md-row g-2">
        <div className="ps-1">
          <BreadCrumb breadCrumbText={breadCrumbText} />
        </div>
        <div className="d-flex justify-content-md-end align-items-center gap-2 flex-wrap">
          {/* -------------- sync ----------------- */}
          <div className="dropdown flex-fill flex-grow-sm-0">
            {/* this is only for admin */}
            {/* <button
              ref={syncBtnRef}
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              disabled={isSyncing}
            >
              <span className="material-symbols-outlined icon-md me-1">
                {isSyncing ? "hourglass_top" : "sync"}
              </span>
              <span className="fw-semibold small">
                {isSyncing ? t("Syncing...") : t("Sync")}
              </span>
              {!isSyncing && (
                <span className="material-symbols-outlined icon-lg ms-1">
                  expand_more
                </span>
              )}
            </button> */}
         
            {/* <ul
              className="dropdown-menu bg-white fs-sm border-0 rounded-3 shadow"
              style={{ maxHeight: 320, overflowY: "auto" }}
            >
              {SYNC_FILES.map((file) => (
                <li key={file}>
                  <button
                    type="button"
                    className="dropdown-item d-flex align-items-center gap-2 py-2"
                    onClick={() => handleSyncClick(file)}
                  >
                    <span className="d-block material-symbols-outlined icon-sm">
                      upload_file
                    </span>
                    <span className="d-block">{getFileLabel(file)}</span>
                  </button>
                </li>
              ))}
            </ul> */}

               {/* sync data only for admin */}
          </div>

          {/* -------------- refresh ----------------- */}
          <Link
            onClick={reloadList}
            to="#"
            className="btn btn-light border d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            title={t("Reload")}
          >
            <span className="material-symbols-outlined icon-md me-1">
              refresh
            </span>
            <span className="fw-semibold small">{t("Reload")}</span>
          </Link>

          <div className="dropdown flex-fill flex-grow-sm-0">
            <button
              className="btn btn-light border d-flex align-items-center px-4 py-2 rounded-3 shadow-sm dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span className="fw-semibold small">{t("Action")}</span>
              <span className="material-symbols-outlined icon-lg ms-1">
                expand_more
              </span>
            </button>
            <ul className="dropdown-menu w-100 bg-white fs-sm border-0 rounded-3 shadow">
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2"
                  to="#"
                  onClick={downloadAsExcel}
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    download
                  </span>
                  <span className="d-block">{t("Download as Excel")}</span>
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item d-flex align-items-center gap-2 py-2 text-danger"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#deletewarning"
                >
                  <span className="d-block material-symbols-outlined icon-sm">
                    delete
                  </span>
                  <span className="d-block">{t("Delete")}</span>
                </Link>
              </li>
            </ul>
          </div>

          <Link
            to="#"
            className={`btn ${
              jsonFilterQuery.length > 0
                ? "btn-outline-primary"
                : "btn-light border"
            } d-flex align-items-center px-4 py-2 rounded-3 shadow-sm`}
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#apiDocAdvanceFilter"
            aria-controls="apiDocAdvanceFilter"
          >
            <span className="material-symbols-outlined icon-md me-1">tune</span>
            <span className="fw-semibold small">{t("Filter")}</span>
            <span
              className={
                jsonFilterQuery.length > 0
                  ? "bg-primary text-white ms-1 rounded-circle fs-xs"
                  : "d-none"
              }
              style={{ minWidth: 22, minHeight: 22 }}
            >
              {jsonFilterQuery.length}
            </span>
          </Link>

          {/* Add API Button */}

          <Link
            to="#"
            className="btn btn-primary d-flex align-items-center px-3 py-2 rounded-3 shadow-sm"
            data-bs-toggle="offcanvas"
            data-bs-target="#apiAdminPopup"
            aria-controls="apiAdminPopup"
          >
            <span className="material-symbols-outlined icon-md me-1">add</span>
            <span className="fw-semibold small">{t("Add API")}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ApiDocsHeader;
